import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Header.css';

const Header = () => {
  const { user, logout, isAdmin } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  if (!user) {
    return null; // Don't show header on login/register pages
  }

  return (
    <header className="header">
      <div className="header-content">
        <Link to="/" className="logo">
          <span className="logo-icon">⚡</span>
          <h1>
            minus<span className="logo-number logo-number-1">1</span>to<span className="logo-number logo-number-0">0</span>
          </h1>
        </Link>
        <nav className="header-nav">
          {isAdmin ? (
            <>
              <Link to="/admin/dashboard" className="nav-link">Dashboard</Link>
              <Link to="/admin/add-problem" className="nav-link">Add Problem</Link>
              <Link to="/leaderboard" className="nav-link">Leaderboard</Link>
            </>
          ) : (
            <>
              <Link to="/user/dashboard" className="nav-link">My Problems</Link>
              <Link to="/leaderboard" className="nav-link">Leaderboard</Link>
              <Link to="/user/profile" className="nav-link">Profile</Link>
            </>
          )}
          <div className="user-info">
            <span className="user-name">{user.name || user.email}</span>
            <button onClick={handleLogout} className="logout-btn">Logout</button>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;

